import type { IOptions } from './interface';
import qs from 'query-string';

export const authApi = new Map();
authApi.set('transform', false);

/**
 * @return timeout 默认的超时时间
 */
export function defaultOptions() {
  return {
    timeout: 60 * 1000,
    ignoreUrlForErrTip: [],
  };
}

export function isBrowser() {
  return (
    typeof window !== 'undefined' && typeof window.document !== 'undefined'
  );
}

export function mergeOption<T>(options: IOptions<T>) {
  const result = {
    ...defaultOptions(),
    ...options,
  };
  return result;
}

export function getQueryString(key: string) {
  try {
    const splitUrl = window.location.href.split('?');
    const uriLen = splitUrl.length;
    let search = '';
    if (uriLen > 1) {
      search = `?${splitUrl[1]}`;
    }
    return qs.parse(search)[key] || '';
  } catch {
    throw new Error('can not get query object');
  }
}

export function getAppInstance() {
  return window.App;
}

export function generatePlusHeader(
  mode: 'five' | 'first' | 'upms' | 'local',
  url: string
) {
  const hashMap = {
    ['five']: () => customFiveAndFirstModeHeader(),
    ['first']: () => customFiveAndFirstModeHeader(),
    ['upms']: () => customUpmsModeHeader(url),
    ['local']: () => customLocalHeader(),
  };
  const result = isShandongSales(url, hashMap[mode]() as any);
  result.prodType =
    getQueryString('gCode') === 'rTrans'
      ? 3
      : getQueryString('gCode') === 'dTrans'
      ? 1
      : 2;
  // 串联判断是否是山东进销存
  return result;
}

export function customFiveAndFirstModeHeader() {
  try {
    const refreshToken = window.localStorage.getItem('refreshToken');
    const accountType = window.localStorage.getItem('accountType');
    const jwtData = getJwtToken();
    return {
      Authorization: jwtData || '',
      refreshToken: refreshToken || '',
      accountType: accountType || '',
    };
  } catch (e: any) {
    throw new Error(e);
  }
}

export function getGcodeValue() {
  return getQueryString('gCode') === 'rTrans'
    ? 3
    : getQueryString('gCode') === 'dTrans'
    ? 1
    : 2;
}

/**
 * get jwt
 */
export function getJwtToken() {
  try {
    return window.localStorage.getItem('token');
  } catch (e: any) {
    throw new Error(e);
  }
}

/**
 * for upms mode
 * @param url
 */
export function customUpmsModeHeader(url: string) {
  const authorizations = [
    '/auth/oauth/token',
    '/upms/user/caCheckUser',
    '/auth/mobile/token/social',
  ];
  // 对接upms登录
  return {
    Authorization:
      authorizations.indexOf(url) !== -1
        ? 'Basic aHhtZWM6aHhtZWM='
        : `Bearer ${getJwtToken()}` || '',
    // 后端需要这个区分药品耗材
    prodType: getGcodeValue(),
    core: 'core',
  };
}

/**
 * for local mode
 */
export function customLocalHeader() {
  return {
    Authorization: getJwtToken() || '',
  };
}

/**
 * 是否是山东进销存
 */
export function isShandongSales(
  url: string,
  headers: ReturnType<typeof customUpmsModeHeader>
) {
  const isSd =
    url.indexOf('/hsaMgr/tps-local/web/mgr/supe/screen/eleven') !== -1;
  if (isSd) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    delete headers.Authorization;
  }
  return headers;
}

export function getTenditmType(systemId: string) {
  const gCode = getQueryString('gCode');
  if (gCode === 'rTender') {
    return '3';
  } else if (
    gCode === 'dTender' ||
    gCode === 'dTrans' ||
    systemId === '1316997647234819502'
  ) {
    return '1';
  } else if (
    gCode === 'cTender' ||
    gCode === 'cTrans' ||
    systemId === '1316997647234819503'
  ) {
    return '2';
  } else if (gCode === 'rTrans') {
    return '3';
  }
}
